import { render, staticRenderFns } from "./editNotLocalButRemote.vue?vue&type=template&id=3168ed9a&scoped=true"
import script from "./editNotLocalButRemote.vue?vue&type=script&lang=js"
export * from "./editNotLocalButRemote.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3168ed9a",
  null
  
)

export default component.exports